export default {
  GET_CLIENT_BILLING_INFO_REQUEST: 'GET_CLIENT_BILLING_INFO_REQUEST',
  EDIT_CLIENT_BILLING_INFO_REQUEST: 'EDIT_CLIENT_BILLING_INFO_REQUEST',
  SET_CLIENT_BILLING_INFO: 'SET_CLIENT_BILLING_INFO',
};
